import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'micro-list-box',
  templateUrl: './micro-list-box.component.html',
  styleUrls: ['./micro-list-box.component.scss']
})
export class MicroListBoxComponent {
  @HostBinding('class.fill-height')
  @Input()
  fillHeight = false;

  @Input()
  title = '';

  @Input()
  items: any;

  @Input()
  displayField: string;

  @Input()
  listSize = 10;

  @Input()
  emptyText = '';

  @Input()
  values: {[key: string]: any};

  @Input()
  itemHeader = '';

  @Input()
  valueHeader = '';

  get isEmpty(): boolean {
    if (!this.items) {
      return true;
    }
    if (typeof this.items.size === 'number') {
      return this.items.size === 0;
    }
    if (typeof this.items.length === 'number') {
      return this.items.length === 0;
    }
    return false;
  }

  getValue(item: any): any {
    if (!this.displayField || item == null || typeof item !== 'object') {
      return item;
    }
    return item[this.displayField];
  }

  getItemValue(item: any): any {
    return this.values?.[this.getValue(item)];
  }

  setItemValue(item: any, value: any): void {
    if (this.values) {
      this.values[this.getValue(item)] = value;
    }
  }
}
